import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const MedicionSchema = yup.object().shape({
  contaminante: yup
    .object()
    .required("errors.medicion.contaminante.required")
    .default(null),
  signo: yup
    .string()
    .max(2, "errors.medicion.signo.max")
    .required("errors.medicion.signo.required")
    .default("="),
  cantidad: CantidadSchema.required("errors.medicion.cantidad.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default(null),
});
